import {BlueBenefitsSubscriptionBase} from "./blue-benefits-subscription-base";

export class UserBlueBenefitsSubscriptionModel extends  BlueBenefitsSubscriptionBase {
    shouldLockFirstPassengerOnBooking(): boolean {
        return true;
    }
}

